// extracted by mini-css-extract-plugin
module.exports = {"callback-wrapper":"Callback_callback-wrapper__2FqYm","lds-hourglass":"Callback_lds-hourglass__3qYaK"};